var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorvector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 299,
    viewBox: "0 0 480 299",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.819 49.6512C185.079 49.2812 189.369 26.8912 197.249 19.5612C206.109 11.2812 223.709 13.7212 222.899 29.3112C222.289 40.9212 213.679 49.6612 202.899 49.6512H202.819ZM211.229 1.99121C178.249 2.43121 166.399 42.2812 182.249 57.6112C198.099 72.9412 237.819 55.1312 237.789 26.8912C237.789 12.4812 226.569 2.00121 211.149 1.99121",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.249 2.92139H286.739C285.619 10.5914 284.739 18.2914 283.549 25.9214H260.939C262.059 18.2414 262.989 10.5414 264.139 2.92139H249.599C243.599 44.3414 243.229 46.8214 236.869 62.7614H251.429C254.724 54.666 257.226 46.27 258.899 37.6914H281.509C279.842 46.2659 277.347 54.6585 274.059 62.7514H288.609C294.839 46.9814 294.959 46.1614 301.269 2.92139",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.119 3.00143H368.579C363.729 36.1014 363.729 36.1014 362.989 39.6314C357.309 27.1114 350.499 15.1914 344.249 2.96143H329.749C323.409 46.3114 323.289 47.1414 317.119 62.7814H331.669C335.019 54.2614 338.259 45.0014 341.159 25.4914C346.669 36.2714 352.809 48.9214 355.999 62.8014H370.559C376.559 47.3614 376.559 47.3614 383.119 2.99142",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.799 49.8314C396.019 49.4414 400.219 27.0914 408.049 19.7714C416.869 11.5214 434.479 13.9614 433.719 29.5114C433.159 41.1014 424.599 49.8414 413.799 49.8314ZM421.999 2.19141C388.999 2.63141 377.289 42.4114 393.309 57.7814C409.489 73.3114 448.769 56.0214 448.639 27.0914C448.579 12.6814 437.369 2.20141 421.999 2.19141Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.57 47.3614C455.08 47.5414 450.42 58.0214 454.51 62.0314C458.98 66.4114 471.13 61.2414 471.2 53.0314C471.2 50.9114 469.85 47.3314 464.57 47.3214V47.3614ZM479.9 0.981445H464.18C459.68 41.1414 459.68 41.1414 459.64 41.3514H471.96C475.25 28.0214 477.25 14.4314 479.9 0.981445Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.939 105.191C153.479 105.121 151.339 104.191 153.759 101.741C165.169 90.0814 192.059 82.4214 192.129 93.2214C192.129 93.7214 191.869 105.331 161.939 105.221V105.191ZM192.379 74.6914C184.379 74.8114 176.869 77.1114 167.319 82.3714C166.969 82.5614 133.529 102.421 136.569 105.461C137.289 106.181 208.969 115.761 209.129 87.9914C209.179 79.6714 202.909 74.7014 192.379 74.6914Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.31 75.6216H267.75C265.13 80.0316 259.68 89.2016 252.23 96.3216L229.58 96.2816C232.16 93.6916 238.22 87.6216 245.1 75.6316H230.53C216.77 98.7016 206.47 104.722 193.34 107.312L207.9 107.382C212.99 106.537 217.866 104.703 222.25 101.982L244.9 102.062C240.517 104.784 235.641 106.616 230.55 107.452L245.11 107.522C258.25 104.892 268.55 98.8316 282.31 75.6216Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.319 75.6816H349.749C343.869 85.6816 336.419 96.7516 325.749 103.072C324.589 93.9516 325.869 84.7916 325.369 75.6616H310.839C297.069 98.9516 286.769 105.042 273.629 107.662L288.189 107.742C294.359 106.492 301.659 104.462 310.189 96.1416C310.429 102.142 310.879 106.012 312.499 107.862L327.059 107.932C339.879 105.312 350.579 99.0016 364.279 75.6816",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.249 106.131C364.459 106.051 362.489 105.061 365.439 102.181C379.299 88.7112 403.489 83.3113 403.519 93.6913C403.519 94.2013 403.199 106.271 373.249 106.131ZM403.689 74.8112C400.469 74.8112 391.899 74.9812 378.739 82.4812C378.379 82.6912 344.119 103.481 348.049 106.541C351.369 109.171 390.689 108.741 403.639 105.201C419.949 100.751 420.839 90.8312 420.469 86.7812C419.769 79.1813 413.659 74.7812 403.689 74.7812",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.809 105.771C417.749 105.771 410.589 107.321 410.289 107.921C410.969 108.711 420.289 108.401 422.679 108.251C429.879 107.801 430.049 106.861 430.009 106.681C429.969 106.501 429.589 105.791 424.809 105.771ZM462.179 73.5114H446.429C438.509 88.9414 430.739 98.6314 421.969 104.011H434.319C438.869 101.451 449.539 95.4414 462.179 73.4814",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.329 118.792C110.329 118.652 110.719 115.082 112.419 113.482C114.539 111.482 119.069 110.142 125.869 109.482C132.669 108.822 150.539 108.482 150.099 110.002C149.909 110.682 133.389 118.802 120.329 118.762V118.792ZM148.249 107.972C112.739 107.822 105.359 110.032 102.929 110.762C92.6494 113.832 93.6794 119.962 96.9294 123.332C101.369 128.002 110.349 129.392 121.559 127.142C135.839 124.272 165.559 110.662 166.559 109.362C166.249 108.812 165.829 108.062 148.299 107.972",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.25 108.492L223.69 108.412C216.79 109.232 214.82 109.592 210.51 110.842L187.86 110.742C191.93 109.552 193.75 109.162 201.04 108.302L186.48 108.222C172.89 109.832 163.7 111.942 150.77 127.732H165.34C168.53 123.882 173.34 118.052 180.94 113.732L203.59 113.822C199.19 116.442 194.69 119.482 188 127.822H202.57C215.07 112.702 223.42 110.282 238.25 108.492Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.249 108.912L305.689 108.832C298.549 109.672 291.799 110.472 284.479 114.782C283.779 110.662 283.029 109.782 281.339 108.712L266.779 108.642C253.199 110.232 244.209 112.022 231.119 127.862H245.679C251.059 121.422 257.679 114.272 268.469 110.992C269.109 112.542 270.179 115.132 270.039 127.902H284.609C297.049 113.052 305.409 110.602 320.249 108.902",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.64 119.421C321.64 119.271 322.01 115.841 323.71 114.301C329.33 109.181 359.4 109.241 361.34 110.831C361.46 112.091 343.52 119.451 331.64 119.421ZM359.5 109.051C335.91 108.951 320.67 109.851 314.22 111.701C302.77 115.001 306.02 121.551 308.22 123.801C312.67 128.311 321.65 129.661 332.87 127.501C346.54 124.861 376.76 111.631 377.76 110.401C377.46 109.901 377.01 109.141 359.49 109.051",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.349 118.282C372.349 118.352 365.729 124.282 368.829 127.402C372.949 131.552 388.379 124.602 388.399 120.312C388.399 118.982 386.699 118.312 383.399 118.312L383.349 118.282ZM418.019 109.282L402.249 109.182C393.499 110.312 387.709 111.062 380.609 115.742H392.959C401.609 111.072 406.409 110.532 417.959 109.222",
    fill: "url(#paint9_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6193 188.122C69.6793 187.732 72.6193 167.892 82.2793 158.982C91.5893 150.372 108.409 149.742 107.939 164.272C107.639 173.502 101.869 188.132 87.6193 188.122ZM104.269 139.122C71.9693 139.592 47.2693 175.522 66.4493 194.052C86.2993 213.182 124.229 194.702 123.339 158.322C123.129 149.572 119.649 139.132 104.269 139.122Z",
    fill: "url(#paint10_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.189 140.051H179.629C175.111 147.714 171.481 155.867 168.809 164.351H146.189C148.846 155.871 152.463 147.721 156.969 140.061H142.409C131.349 159.611 127.919 174.571 124.409 200.711H138.939C140.199 191.431 141.159 184.711 143.009 176.271H165.619C164.159 183.141 163.279 187.801 161.549 200.731H176.079C179.179 177.801 182.079 161.181 194.199 140.061",
    fill: "url(#paint11_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.249 140.102H261.639C256.699 148.732 251.089 159.512 247.069 178.212C243.829 170.612 237.789 156.452 237.289 140.082H222.719C211.519 159.732 208.059 174.682 204.539 200.762H219.069C220.499 190.212 222.279 177.082 226.559 163.872C229.959 173.942 233.489 182.422 243.369 200.792H257.909C260.909 178.612 263.979 161.272 276.209 140.092",
    fill: "url(#paint12_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.479 188.281C280.669 187.901 283.679 168.691 292.649 159.781C301.789 150.701 318.959 149.521 318.979 163.591C318.979 171.651 313.979 188.291 298.479 188.281ZM315.579 139.281C283.169 139.751 258.109 175.721 277.289 194.281C296.889 213.231 334.919 194.701 334.419 158.521C334.299 149.751 330.939 139.301 315.579 139.291",
    fill: "url(#paint13_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.959 185.901C340.239 186.061 336.169 195.141 340.959 199.601C345.749 204.061 356.769 201.031 356.379 192.241C356.239 189.091 353.899 185.911 348.979 185.901H348.959ZM374.289 137.901H358.509C354.399 145.121 347.509 157.211 343.719 179.901H356.049C359.299 167.361 363.749 153.591 374.269 137.901",
    fill: "url(#paint14_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9596 260.642C51.9596 260.232 62.6596 236.342 68.9596 230.362C78.4496 221.302 95.0096 223.732 94.4396 237.062C93.9196 249.192 82.0396 260.652 69.9996 260.642H69.9596ZM84.2496 211.932C49.8196 212.392 36.2496 258.592 48.6196 270.502C62.2696 283.612 110.78 264.022 109.51 233.212C108.99 220.702 98.6096 211.942 84.2496 211.932Z",
    fill: "url(#paint15_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.42 212.851H159.88C158.805 220.747 157.258 228.57 155.25 236.281H132.63C134.656 228.565 136.199 220.73 137.25 212.821H122.72C119.15 236.561 114.55 253.321 100.47 273.911H115.04C120.655 265.968 125.264 257.359 128.76 248.281H151.39C147.922 257.357 143.333 265.964 137.73 273.901H152.3C166.3 253.301 170.87 236.541 174.42 212.801",
    fill: "url(#paint16_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.25 212.931H241.72C240.01 224.441 237.9 236.801 232.57 250.311C229.9 239.971 226.57 230.541 217.42 212.901H202.89C199.34 236.661 194.78 253.431 180.84 274.001H195.41C203.505 262.438 209.453 249.512 212.97 235.841C219.2 252.601 220.12 261.501 219.77 274.021H234.34C248.19 253.461 252.73 236.691 256.26 212.921",
    fill: "url(#paint17_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.189 260.791C263.139 260.381 273.629 236.521 279.859 230.541C289.269 221.541 305.859 223.941 305.379 237.241C304.959 249.351 293.199 260.791 281.189 260.791ZM295.119 212.131C260.759 212.591 247.569 258.741 260.019 270.631C273.219 283.241 320.669 264.631 320.509 234.381C320.439 221.501 309.769 212.151 295.119 212.131Z",
    fill: "url(#paint18_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.61 258.282C322.92 258.472 315.45 269.982 318.81 273.562C322.98 278.002 338.05 271.052 338.05 262.652C338.05 261.652 337.66 258.292 332.61 258.282ZM353.01 210.972H337.29C335.95 224.312 334.29 237.492 328.98 252.112H341.32C346.14 240.942 349.27 231.512 353.01 210.982",
    fill: "url(#paint19_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8094 296.561C16.8594 296.501 16.6494 296.161 16.4594 295.861C17.3294 295.051 31.9694 291.011 40.4594 290.291C49.9694 289.471 54.8794 290.821 54.8194 292.571C54.7594 294.321 49.6794 296.681 25.8194 296.571L25.8094 296.561ZM54.1694 283.141C35.5094 283.281 0.299375 296.061 0.109375 296.141C0.659375 296.911 69.6894 299.711 71.3894 291.051C72.0394 287.731 66.3894 283.131 54.1694 283.051",
    fill: "url(#paint20_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.079 283.912H129.509C125.428 288.148 120.543 291.527 115.139 293.852L92.4892 293.752C97.9108 291.483 102.801 288.112 106.849 283.852H92.2892C81.2892 294.392 76.1992 295.092 57.4092 297.702L71.9692 297.782C84.9192 295.992 84.9192 295.992 85.7092 295.782L108.359 295.892C103.809 296.792 99.1992 297.192 94.6192 297.892L109.179 297.962C127.909 295.392 132.949 294.702 144.079 283.962",
    fill: "url(#paint21_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.099 284.111H211.539C205.009 290.451 199.269 294.521 189.289 296.521C188.289 295.131 187.349 293.031 187.179 284.051H172.609C161.409 294.871 156.389 295.561 137.709 298.121L152.269 298.191C168.319 296.001 168.319 296.001 173.079 294.011C173.759 296.011 173.759 296.011 176.619 298.311L191.179 298.391C209.339 295.931 214.819 295.191 226.099 284.181",
    fill: "url(#paint22_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.04 297.642C228.1 297.582 227.9 297.242 227.71 296.912C228.65 295.992 243.17 291.832 251.71 291.052C261.23 290.192 266.14 291.602 266.07 293.432C265.99 295.432 260.89 297.762 237 297.642H237.04ZM265.45 283.642C246.84 283.792 211.45 297.132 211.3 297.262C211.78 297.962 279.67 301.372 282.54 292.262C283.63 288.782 278.18 283.722 265.45 283.682",
    fill: "url(#paint23_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.569 297.711C282.399 297.711 275.359 298.041 274.359 298.421V298.521C276.529 299.201 292.199 298.681 293.829 298.101L293.769 297.981C292.043 297.713 290.294 297.623 288.549 297.711H288.569ZM324.139 282.861H308.379C302.859 289.061 296.959 294.861 285.509 297.181L297.849 297.241C305.489 295.781 313.849 293.481 324.139 282.891",
    fill: "url(#paint24_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 172.752,
    y1: 74.6914,
    x2: 172.752,
    y2: 107.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 237.825,
    y1: 75.6216,
    x2: 237.825,
    y2: 107.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 318.974,
    y1: 75.6616,
    x2: 318.974,
    y2: 107.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 384.132,
    y1: 74.7812,
    x2: 384.132,
    y2: 108.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 436.234,
    y1: 73.4814,
    x2: 436.234,
    y2: 108.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 130.618,
    y1: 107.964,
    x2: 130.618,
    y2: 128.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#FAFAFA",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.23
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 194.51,
    y1: 108.222,
    x2: 194.51,
    y2: 127.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#FAFAFA",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.23
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 275.684,
    y1: 108.642,
    x2: 275.684,
    y2: 127.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#FAFAFA",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.23
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 341.903,
    y1: 109.044,
    x2: 341.903,
    y2: 128.509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#FAFAFA",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.23
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 393.042,
    y1: 109.182,
    x2: 393.042,
    y2: 128.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#FAFAFA",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.23
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 91.5372,
    y1: 139.122,
    x2: 91.5372,
    y2: 201.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 159.304,
    y1: 140.051,
    x2: 159.304,
    y2: 200.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 240.394,
    y1: 140.082,
    x2: 240.394,
    y2: 200.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 302.519,
    y1: 139.281,
    x2: 302.519,
    y2: 201.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 356.607,
    y1: 137.901,
    x2: 356.607,
    y2: 201.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 76.829,
    y1: 211.932,
    x2: 76.829,
    y2: 274.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.570833,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 137.445,
    y1: 212.801,
    x2: 137.445,
    y2: 273.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.570833,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 218.55,
    y1: 212.901,
    x2: 218.55,
    y2: 274.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.570833,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 287.964,
    y1: 212.131,
    x2: 287.964,
    y2: 274.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.570833,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 335.501,
    y1: 210.972,
    x2: 335.501,
    y2: 274.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.570833,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 35.7745,
    y1: 283.051,
    x2: 35.7745,
    y2: 297.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 100.744,
    y1: 283.852,
    x2: 100.744,
    y2: 297.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 181.904,
    y1: 284.051,
    x2: 181.904,
    y2: 298.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 246.988,
    y1: 283.642,
    x2: 246.988,
    y2: 298.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 299.249,
    y1: 282.861,
    x2: 299.249,
    y2: 298.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 479.8,
    height: 297.88,
    fill: "white",
    transform: "translate(0.0996094 0.961426)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorvector);
export default __webpack_public_path__ + "static/media/errorvector.cd5d4801056018c60cd509436b6ed2ef.svg";
export { ForwardRef as ReactComponent };